<template>
    <div class="basic-wrapper">
        <el-form class="g-form-grid" ref="form" :model="form" label-width="auto" :rules="rules">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-col :span="24">
                        <el-form-item label="场馆名称 :" prop="name">
                            <el-input v-model="form.name" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>


                    <el-col :span="24">
                        <el-form-item label="博物馆地址 :" prop="address">
                            <el-input v-model="form.address" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="电话 :" prop="phone">
                            <el-input v-model="form.phone" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>


                    <el-col :span="24">
                        <el-form-item class="session-form" label="闭馆日期 :" prop="closeTimes">
                            <el-checkbox-group v-model="closeTimes">
                                <div class="week-item" v-for="week in weeks" :key="week.value">
                                    <el-checkbox-button :label="week.value" :key="week.value">{{ week.label
                                    }}</el-checkbox-button>
                                    <span class="icon-span" @click="setGroup(week)"><i class="el-icon-check"></i></span>
                                </div>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="开放时间区间 :" prop="openTimes">
                            <el-time-picker class="w-100" is-range value-format="HH:mm" format="HH:mm" v-model="openTimes"
                                range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="停止入馆时间 :" prop="stopTime">
                            <el-time-picker class="w-100" value-format="HH:mm" format="HH:mm" v-model="form.stopTime"
                                placeholder="选择日期时间"></el-time-picker>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="显示余票数字 :" prop="showTicket">
                            <el-radio-group v-model="form.showTicket">
                                <el-radio label="0">不显示</el-radio>
                                <el-radio label="1">显示</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="单次可预约人数 :" prop="quota">
                            <el-input v-model.number="form.quota" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-col>

                <el-col :span="12">
                    <el-col :span="24">
                        <el-form-item class="avatar-uploader-form" label="活动封面 :" prop="imgId">
                            <div class="uploader-form" @click="uploadPicture(1)">
                                <img v-if="imgUrl" :src="imgUrl" alt="">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </div>
                            <div class="tip-img">建议图片大小：750*500</div>
                        </el-form-item>
                    </el-col>


                    <el-col :span="24">
                        <el-form-item label="预约须知 :" prop="content">
                            <cmp-ckeditor ref="myCkeditor2" :readOnly="pageType === 'detail'" :defaultMsg="form.content"
                                :id="`ue1`" :height="300"></cmp-ckeditor>
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-row>
        </el-form>

        <div class="footer">
            <el-button @click="cancel">取消</el-button>
            <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
        </div>

        <!-- 剪裁组件弹窗 -->
        <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
        </cropper-image>
    </div>
</template>

<script>
import cmpCkeditor from '@cmp/editor/ckeditor'
import CropperImage from "@cmp/cropper"
export default {
    components: { cmpCkeditor, CropperImage },
    data() {
        const validateFile = (rule, value, callback) => {
            if (!this.form.imgId) {
                callback(new Error('活动封面不能为空'))
            } else {
                callback()
            }
        }

        const validateCloseTime = (rule, value, callback) => {
            if (this.closeTimes && this.closeTimes.length == 0) {
                callback(new Error('闭馆时间不能为空'))
            } else {
                callback()
            }
        }

        const validateOpenTime = (rule, value, callback) => {
            if (!this.openTimes) {
                callback(new Error('开放时间不能为空'))
            } else {
                callback()
            }
        }

        const validateContent = (rule, value, callback) => {
            let attention = this.$refs.myCkeditor2.getContent()
            if (!attention) {
                callback(new Error('注意事项不能为空'))
            } else {
                callback()
            }
        }


        // const validateTel = (rule, value, callback) => {
        //     const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        //     if (!this.form.tel) {
        //         callback(new Error('联系电话不能为空'))
        //     } else if (!reg.test(this.form.tel)) {
        //         callback(new Error('请填写正确的手机号'))
        //     } else {
        //         callback()
        //     }
        // }
        return {
            loadingSave: false,
            pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看
            openTimes: null,
            closeTimes: [],
            weeks: [{ label: '周一', value: '1' }, { label: '周二', value: '2' }, { label: '周三', value: '3' }, { label: '周四', value: '4' }, { label: '周五', value: '5' }, { label: '周六', value: '6' }, { label: '周日', value: '7' }],
            form: {
                "id": 1,
                "name": "",
                "imgId": "",
                "openTimes": "",
                "stopTime": "",
                "address": "",
                "content": "",
                "phone": "",
                "closeTime": "",
                "advanceDay": 0,
                "showTicket": "",
                "quota": ""
            },
            imgUrl: '',
            rules: {
                name: [{ required: true, message: '场馆名称不能为空', trigger: 'blur' }],
                address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
                phone: [{ required: true, message: '电话不能为空', trigger: 'blur' }],

                closeTimes: [{ required: true, validator: validateCloseTime, trigger: 'blur' }],
                openTimes: [{ required: true, validator: validateOpenTime, trigger: 'blur' }],
                quota: [
                    { required: true, message: '单次可预约人数不能为空', trigger: 'blur' },
                    {
                        type: 'number',
                        message: '名额必须为数字',
                        trigger: 'blur',
                        transform(value) {
                            // 用于解决数字非必填函数。如果没有该函数，该字段会在表单提交时候进行触发（形成必填字段）
                            return Number(value)
                        }
                    }
                ],
                stopTime: [{ required: true, message: '停止入馆时间不能为空', trigger: 'blur' }],
                showTicket: [{ required: true, message: '是否显示余票不能为空', trigger: 'blur' }],
                // tel: [{ required: true, validator: validateTel, trigger: 'blur' }],
                imgId: [{ required: true, validator: validateFile, trigger: 'change' }],
                content: [{ required: true, validator: validateContent, trigger: 'blur' }],

            },
        }
    },

    watch: {
        $route: {
            handler(to, from) {
                this.$nextTick(()=>{
                    this.$refs['form'].resetFields()
                })
                this.openTimes = null
                this.closeTimes = []
                this.imgUrl = ''
                this.getDetail()
            },
            immediate: true
        }
    },

    methods: {

        getDetail() {
            this.$api.appointSetting.getAppointSettingById({ id: this.$route.query.orgId }).then(res => {
                if (res.success) {
                    this.form = res.result
                    if (this.form.openTimes) {
                        let tempOpenTimes = this.form.openTimes.split('~')
                        this.openTimes = tempOpenTimes
                    }
                    this.form.showTicket = this.form.showTicket.toString()
                    if (this.form.closeTime) {
                        this.closeTimes = this.form.closeTime.split(',')
                    }
                    if (this.form.imgUrl) {
                        this.imgUrl = this.form.imgUrl
                    }
                }
            })
        },

        setGroup(obj) {
            if (this.closeTimes.includes(obj.label)) {
                let index = this.closeTimes.indexOf(obj.label);
                this.closeTimes.splice(index, 1);
            } else {
                this.closeTimes.push(obj.label)
            }

        },

        handleUploadSuccess(result) {
            this.form.imgId = result.attId
            this.imgUrl = result.attPath

            if (this.form.imgId) {
                this.$refs['form'].clearValidate(['imgId'])
            }
            this.cropperModel = false
        },

        //封面设置
        uploadPicture() {
            if (this.pageType == 'detail') {
                return
            }
            let option = {
                cropWidth: "375", cropHeight: "250", imgUrl: this.imgUrl
            }
            this.$refs.cropperRef.initCropper(option)
        },

        // 保存
        fromSubmit(form) {
            let attention = this.$refs.myCkeditor2.getContent(),
                openTimes = ''

            if (this.openTimes) {
                openTimes = this.openTimes[0] + ' ~ ' + this.openTimes[1]
            }

            this.$refs[form].validate(vaild => {
                if (vaild) {
                    let params = {
                        "id": this.$route.query.orgId,
                        "name": this.form.name,
                        "imgId": this.form.imgId,
                        "openTimes": openTimes,
                        "stopTime": this.form.stopTime,
                        "address": this.form.address,
                        "content": attention,
                        "phone": this.form.phone,
                        "closeTime": this.closeTimes.join(','),
                        "advanceDay": this.form.advanceDay,
                        "showTicket": this.form.showTicket,
                        "quota": this.form.quota,
                    }

                    this.loadingSave = true
                    this.$api.appointSetting.saveAppointSetting(params).then(res => {
                        this.loadingSave = false
                        if (res.success) {
                            this.$message.success('保存成功')
                        } else {
                            this.$message.error(res.message || '系统异常')
                        }
                    }).catch(() => {
                        this.loadingSave = false
                    })
                }
            })
        },

        // 取消
        cancel() {
            // this.$refs['form'].resetFields()
            // this.imgUrl = ""
        }
    },

    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.basic-wrapper {
    background: #fff;
    padding: 40px 80px 0 0;
}

.session-form {
    /deep/ .el-form-item__content {

        .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;

            .week-item {
                display: flex;
                margin-right: 10px;
                margin-bottom: 10px;

                &:hover {
                    cursor: pointer;

                    .el-checkbox-button__inner {
                        color: $primary;
                    }

                    .el-icon-check {
                        font-size: 20px;
                        color: #d2d2d2;
                    }
                }

                .el-checkbox-button {
                    outline: none !important;

                    // margin-right: 10px;
                    &.is-checked {
                        .el-checkbox-button__inner {
                            background: $primary ;
                        }

                        &+.icon-span {
                            .el-icon-check {
                                font-size: 20px;
                                color: $primary;
                            }
                        }
                    }

                    .el-checkbox-button__inner {
                        height: 100%;
                        background: #d2d2d2;
                        color: #fff;
                        line-height: 40px;
                        padding: 0 10px;
                    }
                }

                .icon-span {
                    display: flex;
                    box-sizing: border-box;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #DCDFE6;
                    border-left: 0;
                    width: 40px;

                }
            }
        }

        .el-checkbox-button.is-focus .el-checkbox-button__inner {
            border-color: transparent !important;
        }
    }
}

.footer {
    padding-bottom: 20px;
    text-align: right;
}

.avatar-uploader-form {

    .avatar-uploader {
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .el-icon-plus {
            font-size: 20px;
        }

        .el-upload__text {
            line-height: 1;
        }
    }

    .uploader-form {
        width: 100%;
        height: 200px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed #8c939d;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        i {
            font-size: 34px;
        }
    }
}

/deep/.el-time-spinner__list::after,
.el-time-spinner__list::before {
    height: auto;
}
</style>